import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ChartLegendExceptVisualField = ({ isLiveUpdate = null }) => {
  const { t } = useTranslation();
  return (
    <Grid item display="flex">
      <Typography>
        <span style={{ margin: "8px 8px 8px 0px" }}>{t("word_legend")}:</span>
        {isLiveUpdate && (
          <span style={{ color: "#E2772E", margin: "8px" }}>
            {t("current")}
          </span>
        )}
        <span style={{ color: "#13A321", margin: "8px" }}>
          {t("word_seen")}
        </span>
        <span style={{ color: "#B21515", margin: "8px" }}>
          {t("word_not_seen")}
        </span>
        <span
          style={{
            margin: "8px",
            padding: "8px",
            color: "#202338",
            backgroundImage:
              "linear-gradient(0deg, #E7C43C60 25%, #FFF 25%, #FFF 50%, #E7C43C60 50%, #E7C43C60 75%, #FFF 75%, #FFF 100%)",
            backgroundSize: "8px 8px",
          }}
        >
          {t("word_skipped")}
        </span>
      </Typography>
    </Grid>
  );
};

export default ChartLegendExceptVisualField;
